import { useDropdownContext } from "../Dropdown";
import { MenuDivider } from "./MenuDivider";
import { MenuHeader } from "./MenuHeader";
import { MenuOptionItem } from "./MenuOptionItem";
import {
  isMenuCustomElement,
  isMenuDivider,
  isMenuHeader,
  isMenuOption,
  MenuItem,
} from "./types";

type Props = {
  options: MenuItem[];
};

export const MenuContent = ({ options }: Props) => {
  const { activeIndex, contentId } = useDropdownContext();

  const activeDescendant =
    activeIndex !== null ? `${contentId}-option-${activeIndex}` : undefined;
  let optionIndex = 0;

  return (
    <div className="p-1" aria-activedescendant={activeDescendant}>
      {options.map((item, index) => {
        if (isMenuDivider(item)) {
          return <MenuDivider key={index} item={item} />;
        }

        if (isMenuHeader(item)) {
          return <MenuHeader key={index} item={item} />;
        }

        if (isMenuCustomElement(item)) {
          return (
            <div className="w-full" key={index}>
              {item.element}
            </div>
          );
        }

        if (isMenuOption(item)) {
          const currentIndex = optionIndex;
          optionIndex++;
          return (
            <MenuOptionItem key={item.id} option={item} index={currentIndex} />
          );
        }

        return null;
      })}
    </div>
  );
};
